export default __webpack_public_path__ + "static/media/pageLeft.21d287a5.svg";